import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding, OnboardingStatus } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { AnimatePresence, easeInOut, motion } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components/onboarding-trace-link';
type StatusTraceProps = {
  onboarding: EntityOnboarding;
};
export const LatestOnboarding = t0 => {
  const $ = _c(54);
  const {
    onboarding
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "entityStatuses"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t: tStatus
  } = useTranslation("common", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      pass: _temp,
      fail: _temp2,
      none: _temp3,
      incomplete: _temp4,
      pending: _temp5,
      error: _temp6
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const transKeyForStatus = t2;
  let T0;
  let T1;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== onboarding.decisions || $[3] !== onboarding.hasGraphTrace || $[4] !== onboarding.id || $[5] !== onboarding.playbook || $[6] !== onboarding.status || $[7] !== tStatus) {
    const statusColorClass = {
      pass: "text-success",
      fail: "text-error",
      none: "text-neutral",
      incomplete: "text-warning",
      pending: "text-warning",
      error: "text-error"
    };
    let t12;
    if ($[19] !== onboarding.decisions) {
      const orderedDecisions = onboarding.decisions.sort(_temp7);
      t12 = orderedDecisions.find(_temp8);
      $[19] = onboarding.decisions;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    const manualReviewDecision = t12;
    const showStatus = onboarding.status === "pass" || onboarding.status === "fail" || onboarding.status === "incomplete";
    T1 = AnimatePresence;
    t11 = "wait";
    T0 = motion.div;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        height: 0,
        opacity: 0
      };
      t7 = {
        height: "auto",
        opacity: 1
      };
      t8 = {
        height: 0,
        opacity: 0
      };
      t9 = {
        duration: 0.2,
        ease: easeInOut
      };
      $[21] = t6;
      $[22] = t7;
      $[23] = t8;
      $[24] = t9;
    } else {
      t6 = $[21];
      t7 = $[22];
      t8 = $[23];
      t9 = $[24];
    }
    t10 = "overflow-hidden";
    t3 = "px-3 pt-2 pb-2 bg-secondary flex flex-wrap items-center gap-x-2 gap-y-1 justify-center text-center rounded-b-md md:px-0 md:flex-nowrap md:gap-2 md:text-start";
    const t13 = transKeyForStatus[onboarding.status];
    const t14 = showStatus ? "md:mx-1" : "md:ml-1";
    let t15;
    if ($[25] !== onboarding.hasGraphTrace || $[26] !== onboarding.id || $[27] !== onboarding.playbook || $[28] !== t14) {
      t15 = <OnboardingTraceLink onboardingId={onboarding.id} playbook={onboarding.playbook} hasGraphTrace={onboarding.hasGraphTrace} className={t14} />;
      $[25] = onboarding.hasGraphTrace;
      $[26] = onboarding.id;
      $[27] = onboarding.playbook;
      $[28] = t14;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    const t16 = cx(["text-label-2 md:ml-1", statusColorClass[onboarding.status]]);
    let t17;
    if ($[30] !== onboarding.status) {
      t17 = $_5 => $_5[onboarding.status];
      $[30] = onboarding.status;
      $[31] = t17;
    } else {
      t17 = $[31];
    }
    let t18;
    if ($[32] !== t17 || $[33] !== tStatus) {
      t18 = tStatus(t17);
      $[32] = t17;
      $[33] = tStatus;
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    const t19 = {
      playbook: t15,
      status: <span className={t16}>{t18}</span>
    };
    if ($[35] !== t13 || $[36] !== t19) {
      t4 = <span className="text-body-2 text-primary md:flex md:items-center"><Trans ns="entity-details" i18nKey={t13} components={t19} /></span>;
      $[35] = t13;
      $[36] = t19;
      $[37] = t4;
    } else {
      t4 = $[37];
    }
    t5 = manualReviewDecision && <span className="text-body-2 text-primary"><Trans ns="entity-details" i18nKey={_temp9} components={{
        playbook: <OnboardingTraceLink onboardingId={onboarding.id} playbook={onboarding.playbook} hasGraphTrace={onboarding.hasGraphTrace} />,
        status: <span className={cx(["text-label-2 ml-1", statusColorClass[manualReviewDecision.status]])}>{tStatus($_7 => $_7[manualReviewDecision.status])}</span>
      }} /></span>;
    $[2] = onboarding.decisions;
    $[3] = onboarding.hasGraphTrace;
    $[4] = onboarding.id;
    $[5] = onboarding.playbook;
    $[6] = onboarding.status;
    $[7] = tStatus;
    $[8] = T0;
    $[9] = T1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[8];
    T1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t12;
  if ($[38] !== t3 || $[39] !== t4 || $[40] !== t5) {
    t12 = <div className={t3}>{t4}{t5}</div>;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== T0 || $[43] !== t10 || $[44] !== t12 || $[45] !== t6 || $[46] !== t7 || $[47] !== t8 || $[48] !== t9) {
    t13 = <T0 initial={t6} animate={t7} exit={t8} transition={t9} className={t10}>{t12}</T0>;
    $[42] = T0;
    $[43] = t10;
    $[44] = t12;
    $[45] = t6;
    $[46] = t7;
    $[47] = t8;
    $[48] = t9;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  let t14;
  if ($[50] !== T1 || $[51] !== t11 || $[52] !== t13) {
    t14 = <T1 mode={t11}>{t13}</T1>;
    $[50] = T1;
    $[51] = t11;
    $[52] = t13;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  return t14;
};
function _temp($) {
  return $.header.latestOnboarding.lastOnboardedOnto.terminal;
}
function _temp2($_0) {
  return $_0.header.latestOnboarding.lastOnboardedOnto.terminal;
}
function _temp3($_1) {
  return $_1.header.latestOnboarding.lastOnboardedOnto.none;
}
function _temp4($_2) {
  return $_2.header.latestOnboarding.lastOnboardedOnto.incomplete;
}
function _temp5($_3) {
  return $_3.header.latestOnboarding.lastOnboardedOnto.pending;
}
function _temp6($_4) {
  return $_4.header.latestOnboarding.lastOnboardedOnto.error;
}
function _temp7(a, b) {
  return b.createdAt.localeCompare(a.createdAt);
}
function _temp8(d) {
  return !d.isFootprint;
}
function _temp9($_6) {
  return $_6.header.latestOnboarding.manualReview;
}